<template>
    <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
    >
        <template #button-content>
            <div class="d-sm-flex d-none user-nav">
                <p class="user-name font-weight-bolder mb-0">
                    {{ profile.name }}
                </p>
                <span class="user-status">{{ profile.role || '' }}</span>
            </div>
        </template>

        <b-dropdown-item
            :to="{ name: 'pages-profile'}"
            link-class="d-flex align-items-center"
        >
            <feather-icon
                size="16"
                icon="UserIcon"
                class="mr-50"
            />
            <span>Profile</span>
        </b-dropdown-item>
        <b-dropdown-item
            :to="{ name: 'apps-chat' }"
            link-class="d-flex align-items-center"
        >
            <feather-icon
                size="16"
                icon="MessageSquareIcon"
                class="mr-50"
            />
            <span>Chat</span>
        </b-dropdown-item>

        <b-dropdown-divider/>

        <b-dropdown-item
            :to="{ name: 'pages-account-setting' }"
            link-class="d-flex align-items-center"
        >
            <feather-icon
                size="16"
                icon="SettingsIcon"
                class="mr-50"
            />
            <span>Settings</span>
        </b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
import {
    BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import {avatarText} from '@core/utils/filter'

export default {
    components: {
        BNavItemDropdown,
        BDropdownItem,
        BDropdownDivider,
        BAvatar,
    },

    data() {
        return {
            defaultAvatar: require('@/assets/images/avatars/1-small.png'),
            avatarText,
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('logout');

            // Reset ability
            this.$ability.update([{
                action: 'read',
                subject: 'Auth',
            }]);

            // Redirect to login page
            this.$router.push({name: 'auth-login'})
        },
    },
    computed: {
        profile() {
            return this.$store.getters.profile;
        }
    }
}
</script>
